module.exports = __webpack_public_path__ + "static/slack-noise-1-ea1d1aabf59dcd166b8a1ad8cc0bb003.png";